import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { Brain } from 'lucide-react';

const pct = (v) => `${Math.round((v || 0) * 100)}%`;

// Pick a judge from the full list, or tap a Cerebro suggestion
export const JudgePicker = ({ country, caseType, courtLevel, courtSlug, value, onChange, testid = 'judge-picker' }) => {
  const { api } = useAuth();
  const [judges, setJudges] = useState([]);
  const [loadingJudges, setLoadingJudges] = useState(true);
  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    if (!country) return;
    setLoadingJudges(true);
    api.get(`/judicial-intelligence/judges?country=${country}&limit=500`).then((r) => setJudges(r.data.judges || [])).finally(() => setLoadingJudges(false));
  }, [country, api]);

  useEffect(() => {
    if (!country || !caseType) return;
    const q = `country=${country}&case_type=${caseType}${courtLevel ? `&court_level=${courtLevel}` : ''}`;
    api.get(`/judicial-intelligence/suggest-judges?${q}`).then((r) => setSuggestions(r.data.suggestions || []));
  }, [country, caseType, courtLevel, api]);

  const inCourt = courtSlug ? judges.filter((j) => j.court_slug === courtSlug && j.is_active !== false) : [];
  const shown = inCourt.length ? inCourt : judges;
  const ids = new Set(shown.map((j) => j.id));
  const tips = inCourt.length ? suggestions.filter((s) => ids.has(s.judge_id)) : suggestions;

  return (
    <div data-testid={testid} className="space-y-2">
      <select
        data-testid={`${testid}-select`}
        value={loadingJudges ? '' : value || ''}
        disabled={loadingJudges}
        onChange={(e) => onChange(e.target.value || null)}
        className="w-full bg-slate-800 border border-slate-600 rounded-lg px-3 py-2 text-white text-sm"
      >
        <option value="">{loadingJudges ? 'Cargando jueces...' : 'Sin juez asignado'}</option>
        {Object.entries(shown.reduce((g, j) => ({ ...g, [j.court_name || 'Otros']: [...(g[j.court_name || 'Otros'] || []), j] }), {})).sort(([a], [b]) => a.localeCompare(b)).map(([court, js]) => (
          <optgroup key={court} label={court}>{js.map((j) => <option key={j.id} value={j.id}>{`${j.name}${j.position && j.position !== 'Ministro' ? ` · ${j.position}` : ''}`}</option>)}</optgroup>
        ))}
      </select>
      {tips.length > 0 && (
        <div>
          <p className="text-xs text-amber-400 flex items-center gap-1 mb-1"><Brain className="w-3 h-3" />Cerebro sugiere el juez probable:</p>
          <div className="flex flex-wrap gap-2">
            {tips.slice(0, 4).map((s) => (
              <button
                type="button"
                key={s.judge_id}
                data-testid={`${testid}-suggestion-${s.judge_id}`}
                onClick={() => onChange(s.judge_id)}
                className={`text-xs px-2.5 py-1 rounded-full border transition-colors ${value === s.judge_id ? 'bg-amber-500 text-slate-950 border-amber-500' : 'border-slate-600 text-slate-300 hover:border-amber-500'}`}
                title={s.reason}
              >
                {s.name} · {pct(s.win_rate)}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
